var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserFollowLine = function SvgUserFollowLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.8 14.028v1.881a5.4 5.4 0 0 0-7.2 5.093L4.8 21a7.2 7.2 0 0 1 9-6.974v.001ZM12 12.902a5.4 5.4 0 0 1-5.4-5.4c0-2.984 2.417-5.4 5.4-5.4s5.4 2.416 5.4 5.4c0 2.983-2.416 5.4-5.4 5.4m0-1.8c1.989 0 3.6-1.611 3.6-3.6s-1.611-3.6-3.6-3.6a3.6 3.6 0 0 0-3.6 3.6c0 1.989 1.611 3.6 3.6 3.6m5.214 8.022 3.181-3.181 1.274 1.272-4.455 4.455-3.183-3.182 1.274-1.273z"
  })));
};
export default SvgUserFollowLine;